import type { InterestRate } from '../../generated-types';

const getBsuInterest = (interestRates: InterestRate[], accountingBalance: number) => {
    if (interestRates.length === 0) return '';
    const interestRate =
        interestRates.find((interestRate) =>
            accountingBalance >= (interestRate.minimumAmount ?? 0) && interestRate.maximumAmount !== undefined
                ? accountingBalance < interestRate.maximumAmount
                : true,
        ) ?? interestRates[0];
    return `${interestRate.rate} %`;
};

export default getBsuInterest;
